import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import {
  RuleNode,
  RuleGroupNode,
  RuleCondition,
  createEmptyCondition,
  isRuleGroup,
} from 'src/app/models/widget-rule.model';

// Por enquanto (fase 1, igual à VideoWise): lista plana de condições com um
// único operador E/OU pro grupo inteiro — sem "Adicionar grupo"/aninhamento.
// O modelo (RuleGroupNode/children podendo ser outro grupo) já suporta
// aninhamento pra quando isso for reativado numa fase 2.
@Component({
  standalone: true,
  selector: 'app-rule-group',
  templateUrl: './rule-group.component.html',
  styleUrls: ['./rule-group.component.scss'],
  imports: [CommonModule, FormsModule, DropdownModule, SelectButtonModule, ButtonModule, InputTextModule, TooltipModule, RuleGroupComponent],
})
export class RuleGroupComponent {
  @Input() group!: RuleGroupNode;
  @Input() depth: number = 0;

  combinatorOptions = [
    { label: 'E (AND)', value: 'AND' },
    { label: 'OU (OR)', value: 'OR' },
  ];

  // Mesmas 7 opções da VideoWise (URL equals to / not equals to / includes /
  // does not include / starts with / ends with / All website pages).
  operatorOptions = [
    { label: 'URL igual a', value: 'equals' },
    { label: 'URL diferente de', value: 'not_equals' },
    { label: 'URL contém', value: 'contains' },
    { label: 'URL não contém', value: 'not_contains' },
    { label: 'URL começa com', value: 'starts_with' },
    { label: 'URL termina com', value: 'ends_with' },
    { label: 'Todas as páginas do site', value: 'all_pages' },
  ];

  isGroup = isRuleGroup;

  asCondition(node: RuleNode): RuleCondition {
    return node as RuleCondition;
  }

  needsValue(node: RuleNode): boolean {
    return this.asCondition(node).operator !== 'all_pages';
  }

  addCondition(): void {
    this.group.children.push(createEmptyCondition());
  }

  removeChild(index: number): void {
    this.group.children.splice(index, 1);
    // Nunca deixa o grupo vazio — sem filhos ele não tem como ser avaliado.
    if (this.group.children.length === 0) {
      this.group.children.push(createEmptyCondition());
    }
  }
}
